import React from "react";
import moment from "moment";
import { ConfigProvider, Space, Table } from "antd";
import { RoundCheckMark, RoundCheckMarkFilled } from "../../../constants/svg";
import EmptyTableView from "../../EmptyTables/EmptyTableView";
import { tableLoader } from "../../../utils/helper";
import { Assets } from "../../../constants/images";
import ActivityTable from "./ActivityTable";
import AvatarImage from "../../Common/AvatarImage";

const Activities = (props) => {
  const columns = [
    {
      width: "23%",
      title: "Member",
      dataIndex: "alertTitle",
      key: "alertTitle",
      sorter: (a, b) => a.alertTitle.title.localeCompare(b.alertTitle.title),
      sortDirections: ["descend", "ascend", "descend"],
      render: (text, record) => (
        // <NavLink to="/event-detail" className={"black"}>
        <Space size={19}>
          <AvatarImage
            name={record.alertTitle.title}
            src={record.alertTitle.image}
            placeholder={Assets.ProfilePlaceholder}
            size={36}
          />
          <span>{record.alertTitle.title}</span>
        </Space>
        // </NavLink>
      ),
    },
    {
      width: "47%",
      title: "Action",
      dataIndex: "sendType",
      key: "sendType",
      sorter: (a, b) => a.sendType.main.localeCompare(b.sendType.main),
      sortDirections: ["descend", "ascend", "descend"],
      render: (text, record) => (
        <div className="truncateActivityAction">{record.sendType.main}</div>
      ),
      align: "left",
    },
    {
      width: "15%",
      title: "Date/Time",
      dataIndex: "lastSent",
      key: "lastSent",
      sorter: (a, b) => a.lastSent.time.localeCompare(b.lastSent.time),
      sortDirections: ["descend", "ascend", "descend"],
      defaultSortOrder: "descend",
      render: (text, record) => <p>{record.lastSent.main}</p>,
      align: "left",
    },
    {
      width: "15%",
      title: "Clear",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <div
            className={`checkmarkdiv`}
            onClick={() => props?.handleActivityClick(record, props?.readType)}
          >
            {record.checkMark ? (
              <RoundCheckMarkFilled className="checkmark-svg" />
            ) : (
              <RoundCheckMark className="checkmark-svg" />
            )}
          </div>
        </Space>
      ),
    },
  ];
  return (
    <>
      <div
        className={
          props?.data?.length == 0 && !props?.isLoading
            ? "task__container_empty"
            : ""
        }
      >
        <ConfigProvider
          renderEmpty={() => (
            <EmptyTableView
              image={Assets.notificationIcon}
              boldText="Welcome to Salon Symphony!"
              infoText="Activity will appear here as soon as you add your team!"
              action={() => {
                window.open(
                  "https://support.mysalonsymphony.com/hc/en-us/articles/18673510182939-Inviting-Users",
                  "_blank",
                );
              }}
              style={{ paddingTop: "16px" }}
            />
          )}
        >
          <ActivityTable
            getData={props?.getData}
            columns={columns}
            loading={tableLoader(props?.isLoading)}
            page={props?.page}
            store={props?.store}
            readType={props?.readType}
            activeTab={props.activeTab}
            filterKeys={props.filterKeys}
          />
        </ConfigProvider>
      </div>
    </>
  );
};

export default Activities;
